import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { actions, selectors } from 'src/store';
import { paths } from 'src/constants';

import wood from 'src/images/memory/wood.svg';

import { Container } from './components';

const MemoryStepOneGroups = ({
  getGroups,
  hasLoaded,
  memoryStepOneCurrency,
  memoryStepOneGroups,
  student,
}) => {
  return (
    <Container
      cardBackgroundImage={wood}
      className="memory-groups-container--step-one"
      collectionsPath={paths.MEMORY_STEP_ONE_COLLECTIONS}
      currency={memoryStepOneCurrency}
      getGroups={getGroups}
      hasLoaded={hasLoaded}
      items={memoryStepOneGroups}
      student={student}
    />
  );
};

MemoryStepOneGroups.propTypes = {
  getGroups: PropTypes.func.isRequired,
  hasLoaded: PropTypes.bool.isRequired,
  memoryStepOneCurrency: PropTypes.shape({}).isRequired,
  memoryStepOneGroups: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  student: PropTypes.shape({}).isRequired,
};

const mapStateToProps = (state) => ({
  hasLoaded: selectors.memoryStepOneGroups.getHasLoaded(state),
  memoryStepOneCurrency: selectors.memoryStepOneGroups.getCurrencyData(state),
  memoryStepOneGroups: selectors.memoryStepOneGroups.getGroupsData(state),
  student: selectors.authentication.getStudent(state),
});

const mapDispatchToProps = {
  ...actions.memoryStepOne,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  memo
)(MemoryStepOneGroups);
